/**
 * Screw compressor female rotor end profile icon
 * 6-lobe concave profile typical of female rotors
 */
export default function RotorIcon({ size = 16, color = "#1D4ED8", className = "" }) {
  const r = size / 2;
  const cx = r;
  const cy = r;
  const outerR = r * 0.92;
  const innerR = r * 0.52;
  const lobes = 6;

  // Generate the female rotor profile path (concave lobes)
  let path = "";
  for (let i = 0; i < lobes; i++) {
    const angle1 = (i / lobes) * Math.PI * 2 - Math.PI / 2;
    const angle2 = ((i + 0.5) / lobes) * Math.PI * 2 - Math.PI / 2;
    const angle3 = ((i + 1) / lobes) * Math.PI * 2 - Math.PI / 2;

    const x1 = cx + outerR * Math.cos(angle1);
    const y1 = cy + outerR * Math.sin(angle1);
    const xMid = cx + innerR * Math.cos(angle2);
    const yMid = cy + innerR * Math.sin(angle2);
    const x2 = cx + outerR * Math.cos(angle3);
    const y2 = cy + outerR * Math.sin(angle3);

    // Control points for smooth concave curves
    const cp1x = cx + outerR * 0.65 * Math.cos(angle1 + 0.25);
    const cp1y = cy + outerR * 0.65 * Math.sin(angle1 + 0.25);
    const cp2x = cx + outerR * 0.65 * Math.cos(angle3 - 0.25);
    const cp2y = cy + outerR * 0.65 * Math.sin(angle3 - 0.25);

    if (i === 0) {
      path += `M ${x1.toFixed(2)} ${y1.toFixed(2)} `;
    }
    path += `Q ${cp1x.toFixed(2)} ${cp1y.toFixed(2)} ${xMid.toFixed(2)} ${yMid.toFixed(2)} `;
    path += `Q ${cp2x.toFixed(2)} ${cp2y.toFixed(2)} ${x2.toFixed(2)} ${y2.toFixed(2)} `;
  }
  path += "Z";

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="rotor-icon"
    >
      {/* Outer circle (casing) */}
      <circle cx={cx} cy={cy} r={outerR} stroke={color} strokeWidth={0.5} fill="none" opacity={0.3} />
      {/* Rotor profile */}
      <path d={path} fill={color} opacity={0.85} />
      {/* Center bore */}
      <circle cx={cx} cy={cy} r={r * 0.15} fill="white" />
    </svg>
  );
}
